
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, startWith, Subject, takeUntil } from 'rxjs';
import { Guid } from '@modules/shared/helpers/guid-helper';
import { SvgIconComponent } from '@modules/shared/components/svg-icon/svg-icon.component';
import { FormControl } from '@angular/forms';
import { FormSelectOption } from './interfaces/form-select-option';

@Component({
    selector: 'app-form-select',
    imports: [NgClass, AsyncPipe, TranslateModule, SvgIconComponent],
    templateUrl: './form-select.component.html',
    styleUrls: ['./form-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSelectComponent implements OnInit, OnDestroy {
  @Input({required: true}) options$: BehaviorSubject<FormSelectOption[]>;
  @Input({required: true}) control: FormControl<string | number>;
  @Input() showFor$: BehaviorSubject<string>;
  @Input() label = '';
  @Input() id = Guid.newGuid();
  @Input() disabled = false;
  
  protected selectActive = false;

  private readonly _destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.control.valueChanges.pipe(
      startWith(this.control.value), 
      takeUntil(this._destroy$)
    ).subscribe((selectedOption) => {
      const options: FormSelectOption[] = this.options$.value;
      const updatedOptions = options.map((option) => {
        if (option.value !== selectedOption && option.selected) {
          option.selected = false;
          return {...option};
        }
        if (option.value === selectedOption && !option.selected) {
          option.selected = true;
          return {...option};
        }
        return option;
      });
      this.options$.next(updatedOptions);
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  protected onChangeSelect(selectedOption: FormSelectOption): void {
    this.control.setValue(selectedOption.value);
  } 

  protected onKeydownSelect(event: KeyboardEvent): void {
    if (event.code === "Enter" || event.code === "Space") {
      this.selectActive = !this.selectActive;
      event.stopPropagation();
    }
  } 

  protected onClickSelect(): void {
    this.selectActive = !this.selectActive;
  }

  protected trackByFunction(i, {value}): string | number {
 return value; 
}
}